import { render, staticRenderFns } from "./ride-message-section.vue?vue&type=template&id=0513110d"
import script from "./ride-message-section.vue?vue&type=script&lang=js"
export * from "./ride-message-section.vue?vue&type=script&lang=js"
import style0 from "./ride-message-section.vue?vue&type=style&index=0&id=0513110d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports